import {
  CREATE_CCPA_REQUEST, 
  CREATE_CCPA_REQUEST_ERROR, 
  CREATE_CCPA_REQUEST_SUCCESS,
  RESET_TOAST_MESSAGE,
  SHOW_TOAST_ALERT,

} from "./actionTypes"

export const createCCPARequest = (payload) => ({
  type: CREATE_CCPA_REQUEST,
  payload: payload
})

export const createCCPARequestSuccess = (payload) => ({
  type: CREATE_CCPA_REQUEST_SUCCESS,
  payload: payload
})

export const createCCPARequestError = (error) => ({
  type: CREATE_CCPA_REQUEST_ERROR,
  payload: error
})

export const showToastAlert = (message) => ({
  type: SHOW_TOAST_ALERT,
  payload: message
})

export const resetToastMessage = () => ({
  type: RESET_TOAST_MESSAGE,
})
